import Image from '@ingka/image';
import { translate } from '@repo/phrase';
import type { AssetDrawing } from '@repo/types/asset';
import { Heading, Paragraph } from '@repo/ui/typography';
import { isActionKey } from '@repo/utils';

import sharedStyles from '@/components/asset-details/asset-drawings/styles.module.scss';
import styles from './styles.module.scss';

interface Props {
    item: AssetDrawing;
}

export const DrawingItem = ({ item }: Props) => {
    const { drawingId, drawingName, drawingIdSource } = item;
    const drawingImage = item.imageUrl;
    const drawingUrl = item.drawingUrl;

    const viewDrawing = () => {
        if (!drawingUrl) {
            return;
        }
        window.open(drawingUrl, '_blank');
    };

    return (
        <div className={`${sharedStyles.drawing_table_row} ${styles.row_drawing}`}>
            <div>
                <div
                    className={styles.drawing_image_container}
                    onClick={viewDrawing}
                    onKeyDown={(event) => {
                        isActionKey(event.key) && viewDrawing();
                    }}
                    aria-label="drawing-image"
                    // oxlint-disable-next-line jsx-a11y/prefer-tag-over-role
                    role="button"
                    data-testid="drawing-img-container"
                    tabIndex={0}
                >
                    <Image
                        src={drawingImage ?? ''}
                        fallback={!drawingImage}
                        alt={drawingImage ?? translate('no_image')}
                    />
                </div>
                <div>
                    <Heading headingSize="xs">{drawingName}</Heading>
                    <Paragraph bodySize="s">{drawingId}</Paragraph>
                </div>
            </div>
            <div>
                <Paragraph bodySize="s">{drawingIdSource}</Paragraph>
            </div>
        </div>
    );
};
